export default __webpack_public_path__ + "static/media/aun-Logo-png.ed7cef9b.png";